import React from 'react';
import { useAppSelector } from '../store/hooks';
import {
  getWeeklyOrderCount,
  getWeeklyCompletedOrderCount,
  getWeeklyPendingOrderCount,
  getWeeklyInProgressOrderCount
} from '../utils/orderUtils';

export const Home: React.FC = () => {
  // Get orders from Redux store
  const orders = useAppSelector(state => state.orders.orders);

  // Calculate weekly order counts
  const weeklyCount = getWeeklyOrderCount(orders);
  const weeklyCompletedCount = getWeeklyCompletedOrderCount(orders);
  const weeklyPendingCount = getWeeklyPendingOrderCount(orders);
  const weeklyInProgressCount = getWeeklyInProgressOrderCount(orders);

  // Format current date as "Weekday, Month Day"
  const getCurrentDate = () => {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    };
    return now.toLocaleDateString('en-US', options);
  };

  return (
    <div className="container" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <header style={{ marginBottom: '40px' }}>
        <h1 style={{ fontSize: '2.5rem', color: '#333' }}>Deb's Meatbuns Management</h1>
        <p style={{ color: '#666', fontSize: '2rem', fontWeight: '400', marginTop: '12px', marginBottom: '4px' }}>
          {getCurrentDate()}
        </p>
        <p style={{ color: '#2196F3', fontSize: '1.2rem', fontWeight: '500', marginTop: '8px', marginBottom: '4px' }}>
          You've received {weeklyCount} new {weeklyCount === 1 ? 'order' : 'orders'} this week!
        </p>
        <p
          style={{
            color: '#666',
            fontSize: '1rem',
            fontWeight: '400',
            marginTop: '4px',
            marginBottom: '8px',
            marginLeft: '20px'
          }}
        >
          {weeklyPendingCount} pending, {weeklyInProgressCount} in progress
        </p>
        <p style={{ color: '#4CAF50', fontSize: '1.2rem', fontWeight: '500', marginTop: '8px', marginBottom: '8px' }}>
          You've completed {weeklyCompletedCount} {weeklyCompletedCount === 1 ? 'order' : 'orders'} this week!
        </p>
        <p style={{ color: '#666', fontSize: '1.1rem', marginTop: '8px' }}>Recipe and order management system</p>
      </header>
    </div>
  );
};
